var _defs, _rect, _rect2, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTailLift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #3b66b0;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 29.5,
    y: 5.5,
    width: 5.2,
    height: 20.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.2,
    y: 29.7,
    width: 20.5,
    height: 5.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 32.1,
    cy: 31.8,
    r: 3.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.2,29.3c-.6,0-1.1-.4-1.2-1.1h0v-1.1h0c0-.7.5-1.3,1.2-1.3s1.2.5,1.2,1.1h0v1.1h0c0,.6-.5,1.2-1.1,1.2h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.7,24h-.2c-.5,0-.9-.5-.9-1.1s0-.1,0-.2c0-.4,0-.7.2-1.2s.7-.9,1.4-.7c.2,0,.5.2.6.5s0,.5,0,.7c0,.2,0,.5-.2.9h0c0,.6-.5,1.1-1.1,1.1,0,0,.2,0,.2,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.6,19h-.5c-.4-.1-.6-.5-.6-.9s0-.4,0-.5c0-.4.4-.6.5-1.1.2-.5,1.1-.6,1.6-.4s.7.9.4,1.4c-.1.2-.4.6-.5.9h0c-.1.4-.5.6-1.1.6h.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.8,14.5c-.2,0-.5,0-.7-.2s-.4-.5-.4-.7,0-.5.2-.7l.7-.7c.2-.2,1.2-.4,1.6,0,.5.4.5,1.2,0,1.6l-.7.7c-.2.2-.5.4-.9.4h.2v-.3h0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.1,11.1c-.4,0-.7-.1-.9-.5-.1-.1-.1-.4-.1-.6,0-.4.1-.6.5-.9.4-.2.6-.4,1.1-.6.5-.2,1.3,0,1.6.4.1.2.1.5,0,.7,0,.2-.2.5-.5.6-.2.1-.6.4-.9.5-.1,0-.4.1-.6.1h0v.2h-.2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21,8.8c-.5,0-.9-.2-1.1-.7v-.4c0-.4.2-.7.5-.9h.4c.4,0,.7-.2,1.1-.2.6,0,1.3.2,1.4.7s-.1,1.2-.7,1.3c-.4,0-.6.1-1.1.2h-.5,0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.6,7.7c-.6,0-1.2-.4-1.2-1.1h0c0-.6.5-1.2,1.1-1.2h1.2c.6,0,1.2.5,1.2,1.1s0,.5-.4.7c-.2.2-.5.2-.7.4h-1.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailLift);
export default __webpack_public_path__ + "static/media/tail-lift.2610f0eb1b872046b1cf644af9016e1f.svg";
export { ForwardRef as ReactComponent };